import { Expose } from 'class-transformer';

export class MedicalDeviceReleaseConfigResponseDto {
    /**
     * Medical device release configuration ID
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @Expose()
    id: string;

    /**
     * Client Information Record ID
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @Expose()
    clientInformationRecordId: string;

    @Expose()
    deviceClass?: string;

    /**
     * Are medical devices received into quarantine?
     * @example false
     */
    @Expose()
    receivedIntoQuarantine: boolean;

    /**
     * Is verification by QC required?
     * @example false
     */
    @Expose()
    verificationByQcRequired: boolean;

    /**
     * Is destruction approved by QC?
     * @example false
     */
    @Expose()
    destructionApprovedByQc: boolean;

    /**
     * Notes on medical device release process
     * @example 'N/A - Not applicable for Jazz products'
     */
    @Expose()
    notes?: string;

    /**
     * Creation timestamp
     * @example '2024-01-15T10:30:00Z'
     */
    @Expose()
    createdAt: Date;

    /**
     * Last update timestamp
     * @example '2024-01-15T14:45:00Z'
     */
    @Expose()
    updatedAt: Date;
}
